import React, { useState } from 'react';
import moment from 'moment';
import { Link, useParams } from 'react-router-dom';
import InfoReleaseNotes from '../InfoReleaseNotes';
import Pagination from "react-js-pagination";


export default function ListReleaseNotes(props) {
    const { releaseNotes, setReloadReleaseNotes, location, history } = props;
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(10);
    const { url } = useParams();

    return (
        <div className="col-md-12 col-xl-15 py-md-3 pl-md-1 bd-content">
            {url ? (
                <InfoReleaseNotes url={url} />
            ) : (
                <ListPreview 
                    releaseNotes={releaseNotes} 
                    setReloadReleaseNotes={setReloadReleaseNotes}
                    location={location}
                    history={history}
                    postsPerPage={postsPerPage}
                    totalPosts={releaseNotes.length}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
        </div>
    )
}

function ListPreview(props) {
    const { 
            releaseNotes,
            postsPerPage,
            totalPosts,
            setCurrentPage,
            currentPage
        } = props;
    
    // Busqueda actual
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    let currentPosts = releaseNotes.slice(indexOfFirstPost, indexOfLastPost);

    // Cambiar página
    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (
        <>
            {Array.from(currentPosts).map((notes, index) => {
                return(
                    <div key={index}>
                        
                        <div className="row mt-3">
                            <div className="col-12">
                                <h3 id="responsive-meta-tag">
                                    <Link 
                                        to={"/search/"+notes.url}    
                                    >
                                        <span className="bd-content-title">{notes.nm_titulo}</span>
                                    </Link>
                                </h3>
                                <span className="col-12 p-0 text-right text-secundary fecha-busqueda">Publication Date: {moment(notes.fc_creacion).format("DD/MM/YYYY")}</span>
                                <div className="filter-tag-container text-primary">
                                    {notes && notes.id_categoria && notes.id_categoria.nm_categoria ? (
                                        <span>
                                            {notes.id_categoria.nm_categoria}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                    {notes && notes.id_subcategoria && notes.id_subcategoria.nm_subcategoria ? (
                                        <span>
                                            {">"+notes.id_subcategoria.nm_subcategoria}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                        <hr/>
                    </div>
                )
            })}
            
            <div className='pagination float-right'>
                <Pagination
                    hideFirstLastPages
                    prevPageText='Anterior'
                    nextPageText='Siguiente'
                    activePage={currentPage}
                    itemsCountPerPage={10}
                    totalItemsCount={totalPosts}
                    pageRangeDisplayed={5}
                    onChange={paginate}
                    itemClass="page-item"
                    linkClass="page-link"
                />
            </div>
        </>
    )
}